import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPostModel } from '@app/pages/posts/models/post.model';
import { EImageType, ImagePipe } from '@shared/pipes/image.pipe';
import { QuillModule } from 'ngx-quill';

@Component({
  selector: 'beh-shareable-post-presenter',
  imports: [
    ImagePipe,
    QuillModule
  ],
  templateUrl: './share-post-dialog.component.html',
  styleUrl: './share-post-dialog.component.scss'
})
export class SharePostDialogComponent {
  data = inject<IPostModel>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<SharePostDialogComponent>>(MatDialogRef);

  imageType = EImageType;

  closeDialog() {
    this.dialogRef.close();
  }
}
